module.exports = __webpack_public_path__ + "static/img/sergey-zolkin-192937-unsplash.5d11f77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/New folder/sergey-zolkin-192937-unsplash.jpg
// module id = wE6U
// module chunks = 1